import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';

import {VoucherDomainsRepository} from '../repositories/voucher-domains.repository';

import {Domain} from 'classes/domain';

@Injectable()
export class VoucherDomainsService {

  constructor(private voucherDomainsRepository: VoucherDomainsRepository) { }

  public getAllDomains(): Observable<Array<Domain>> {
    return this.voucherDomainsRepository.getAllDomains();
  }

  public saveNewDomain(name: string): Observable<Domain> {
    return this.voucherDomainsRepository.saveNewDomain(name);
  }

  public updateDomain(id: number, name: string): Observable<Domain> {
    return this.voucherDomainsRepository.updateDomain(id, name);
  }

  public deleteDomain(id: number): Observable<boolean> {
    return this.voucherDomainsRepository.deleteDomain(id);
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/voucher/voucher-domains/services/voucher-domains.service.ts